import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { Alert, Autocomplete, Backdrop, Button, Chip, CircularProgress, Grid, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { deleteInsurance, getInsurance, getOrgCn, insuranceBooking, validCn, validPrice } from "./booking_halper";
import DeleteIcon from '@mui/icons-material/Delete';
import { dateUsaToTimestamp, getCurrentDate } from "../frames/common";
import DropDownLoading from "../frames/dropdown_loading";
import { useSearchParams } from "react-router-dom";


const cu_date = getCurrentDate();

function Insurance() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [inputErrors, setInputErrors] = useState({});
    const [cnList, setCnList] = useState(null);
    const [bookingList, setBookingList] = useState(null);
    const [alertMessage, setAlertMessage] = useState(null);

    const initData = async (auth) => {
        if (!auth) return;
        setCnList(await getOrgCn());
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const date = dateUsaToTimestamp(data.get("date"));
        const cn_no = data.get("cn_no");
        const description = data.get("desc");
        const total = data.get("insurance");

        var flag = true;
        if (__error_handler(validCn(cn_no), "cn_no", "Incorrect consignment number.")) {
            flag = false;
        } else if (__error_handler(Number(total) > 5, "insurance", "Price should be greter than ₹5.")) {
            flag = false;
        }

        if (flag) {
            const _json = { "cn_num": cn_no, "description": description, "amount": Number(total), "date": date }
            insuranceBooking(_json).then((_) => {
                setAlertMessage({ severity: "success", message: "The insurance is booked succefully." });
                setIsLoading(false);
                event.target.reset();
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err['message'] });
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const validateInputs = () => {
        setIsLoading(true);
        return true;
    }

    const handleCnChange = (event) => {
        const cn = event.target.value.toUpperCase();
        if (!cn || !validCn(cn)) return;
        if (searchParams.get("cn"))
            setSearchParams({})
        setIsLoading(true);
        getInsurance(cn).then((res) => {
            document.getElementsByName("desc")[0].value = "Insurance for " + cn;
            setBookingList(res);
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
            console.error(err);
        })
    }

    const handleInsuranceChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "insurance", "Please fill a valid amount.");
    }

    const handleDeleteInsurance = (insurance) => {
        if (insurance.ispaid === 0) {
            setIsLoading(true);
            deleteInsurance({ "insurance_id": insurance.insurance_id }).then((res) => {
                console.log(res);
                setIsLoading(false);
                setBookingList(bookingList.filter(element => element.insurance_id !== insurance.insurance_id));
            }).catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
        } else {
            setAlertMessage({ severity: "error", message: "This insurance is already paid. You can not modify details." });
        }
    }

    return (
        <MenuFrame permission="BOOKING_ORG" screen="INSURANCE" onInit={initData}>
            {cnList === null || cnList.length === 0 ? <LinearProgress color="primary" /> : ""}
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                    {alertMessage === null ? "" :
                        <Grid size={12}>
                            <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                        </Grid>
                    }
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="date" type="date" fullWidth error={inputErrors.date} defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2024-04-01" } }} helperText={inputErrors.date} placeholder="Date" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Autocomplete
                            disablePortal
                            defaultValue={searchParams.get("cn") ?? ""}
                            noOptionsText={<DropDownLoading title="Loading Consignment ..." />}
                            options={cnList === null ? [] : cnList}
                            onBlur={handleCnChange}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="cn_no" fullWidth error={inputErrors.cn_no} type="text" helperText={inputErrors.cn_no} autoFocus placeholder="Consignment Number" label="CN Number" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="insurance" defaultValue={0} fullWidth error={inputErrors.insurance} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.insurance} placeholder=" ₹" label="Insurance Charge" onKeyUp={handleInsuranceChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <TextField variant="outlined" name="desc" defaultValue={" "} fullWidth error={inputErrors.description} type="text" helperText={inputErrors.description} placeholder="Description" label="Description" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                    </Grid>
                </Grid>
                {bookingList === null || bookingList.length === 0 ? "" :
                    <TableContainer component={Paper}>
                        <Table size="small" sx={{ minWidth: "100%" }} aria-label="Insurance Details" className="nowrap">
                            <TableHead>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Consignment</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell><Chip label="Amount" size="small" color="success" /></TableCell>
                                    <TableCell align="right">&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    bookingList.map((item, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell>IDT{item.insurance_id}</TableCell>
                                                <TableCell>{item.created}</TableCell>
                                                <TableCell>{item.cn_ref}</TableCell>
                                                <TableCell>{item.description}</TableCell>
                                                <TableCell><Chip label={"₹" + item.amount.toFixed(2)} size="small" color="success" /></TableCell>
                                                <TableCell align="right">
                                                    <IconButton color="error" aria-label="delete" onClick={(e) => handleDeleteInsurance(item)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>
        </MenuFrame>
    );
}

export default Insurance;